import type { Custodian } from 'models/custodian';
import type { Collection } from 'state/utils/types';

import type { TradeWay } from '../../secondaryMarket.model';

export const allOrderTypes = ['Market', 'Limit'] as const;
export type OrderType = (typeof allOrderTypes)[number];
export const allLimitValidities = ['DAY', 'GTC', 'GTD'] as const;
export type LimitValidity = (typeof allLimitValidities)[number];

export interface DlpOrderFormModel {
  tradeWay: TradeWay;
  quantity?: number;
  orderType: OrderType;
  validity?: LimitValidity;
  limit?: number;
  limitDate?: string;
  limitTime?: string;
  custodian?: Custodian;
}

export type SecondaryMarketDlpOrderField = keyof DlpOrderFormModel;

export type DlpOrderState = DlpOrderFormModel;
export type SecondaryMarketDlpOrderTabContent = DlpOrderFormModel;

export type SecondaryMarketDlpOrderForm = Collection<DlpOrderState>;

export const initialDlpOrderForm = {};
export const initialSecondaryMarketDlpOrderForm: DlpOrderFormModel = {
  tradeWay: 'ClientSell',
  orderType: 'Market',
};
